import React, { useRef, useState } from 'react';
import { Box, VStack, Popover, Portal } from '@chakra-ui/react';
import { HiOutlineCamera, HiOutlineDocument, HiPlus, HiXMark } from 'react-icons/hi2';
import AttachmentRow from './AttachmentRow';

const AttachmentMenu = ({ onFileSelect, colors, isSending }) => {
    const [open, setOpen] = useState(false);
    const imageInputRef = useRef(null);
    const docInputRef = useRef(null);

    const handleFileChange = (e, type) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (ev) => {
            onFileSelect({ type, content: ev.target.result, filename: file.name });
        };
        reader.readAsDataURL(file);
        e.target.value = null;
        setOpen(false);
    };

    return (
        <Popover.Root open={open} onOpenChange={({ open }) => setOpen(open)} positioning={{ placement: 'top-start' }}>
            <Popover.Trigger asChild>
                <Box
                    as="button"
                    disabled={isSending}
                    p={2}
                    borderRadius="full"
                    color={isSending ? 'rgba(134,36,244,0.4)' : '#A424F4'}
                    cursor={isSending ? 'not-allowed' : 'pointer'}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    transition="background 0.15s"
                    _hover={!isSending ? { bg: colors.inputBg } : {}}
                    flexShrink={0}
                    aria-label="Załącznik"
                >
                    {open ? <HiXMark size={22} /> : <HiPlus size={22} />}
                </Box>
            </Popover.Trigger>
            <Portal>
            <Popover.Positioner>
                <Popover.Content
                    bg={colors.attachmentBg}
                    borderWidth="1px"
                    borderColor={colors.borderColor}
                    borderRadius="16px"
                    boxShadow="0 4px 24px rgba(0,0,0,0.12)"
                    overflow="hidden"
                    minW="240px"
                    p={0}
                >
                    <input
                        type="file"
                        ref={imageInputRef}
                        style={{ display: 'none' }}
                        accept="image/jpeg,image/png,image/heic,image/heif"
                        onChange={(e) => handleFileChange(e, 'image')}
                    />
                    <input
                        type="file"
                        ref={docInputRef}
                        style={{ display: 'none' }}
                        accept=".pdf,.docx,.doc"
                        onChange={(e) => handleFileChange(e, 'file')}
                    />
                    <VStack gap={0}>
                        <AttachmentRow
                            icon={<HiOutlineCamera size={20} color="#A424F4" />}
                            label="Zdjęcie / galeria"
                            subLabel="JPG, PNG, HEIC"
                            onClick={() => imageInputRef.current?.click()}
                            colors={colors}
                        />
                        <AttachmentRow
                            icon={<HiOutlineDocument size={20} color="#4A90D9" />}
                            label="Dokument"
                            subLabel="PDF, DOCX, DOC"
                            onClick={() => docInputRef.current?.click()}
                            colors={colors}
                        />
                    </VStack>
                </Popover.Content>
            </Popover.Positioner>
            </Portal>
        </Popover.Root>
    );
};

export default AttachmentMenu;
